import * as Actions from '../actions'
import { LoftServices } from '../../../types/loft'
import * as Validation from '../validation'

Actions.withOperationName(Actions)

export default [
  Actions.awaitAsync('attendees', ({ office }: LoftServices) => office.item.getAttendees()),
  Validation.throwOnInvalidAttendees,
  Actions.awaitAsync('recurrence', ({ office }: LoftServices) => office.item.getRecurrence()),
  Validation.throwOnInvalidRecurrence,
  Actions.awaitAsync('attachments', ({ office }: LoftServices) =>
    office.item.getAppointmentAttachments()
  ),
  Actions.awaitAsync('organizer', ({ office }: LoftServices) => office.item.getOrganizer()),
  Actions.awaitAsync('subject', ({ office }: LoftServices) => office.item.getSubject()),
  Actions.awaitAsync('crmReferences', ({ office }: LoftServices) => office.item.getCrmReferences()),
  Actions.awaitAsync('meetingTypeId', ({ office }: LoftServices) => office.item.getMeetingTypeId()),
  Actions.awaitAsync('location', ({ office }: LoftServices) => office.item.getLocation()),
  Actions.awaitAsync('body', ({ office }: LoftServices) => office.item.getBody()),
  Actions.awaitAsync('crmCustomFields', ({ office }: LoftServices) =>
    office.item.getCrmCustomFields()
  ),
  Actions.awaitAsync('mainGuest', ({ office }: LoftServices) => office.item.getMainGuest()),
  Actions.awaitAsync('startTime', ({ office }: LoftServices) => office.item.getStartTime()),
  Actions.awaitAsync('endTime', ({ office }: LoftServices) => office.item.getEndTime()),
  Actions.awaitAsync('itemId', ({ office }: LoftServices) => office.item.getItemId()),
  Actions.updateProgress('connecting_salesloft'),
  Actions.getEventData,
  Actions.calendarLoft,
  Actions.stopProgress,
  Actions.loftSuccess,
  Actions.appointmentClose,
]
